// eslint-disable-next-line
export const SET_VISIBLE_MODAL = 'modal/set-visible-modal';
export const SET_INFO = 'modal/set-info';
